<template>
  <div class="login">
    <!--登录引导-->
    <div class="login-guide" v-if="showGuide">
      <LoginGuidePage />
    </div>
    <div class="title">
      <img
        class="guide-logo-icon"
        src="@/assets/style/guide-logo-icon.png"
        alt=""
      />
      <span>欢迎来到新享管家</span>
    </div>
    <div class="login-content">
      <!--手机号-->
      <phoneField v-model="phone" />
      <!--验证码-->
      <codeField v-model="code" :phone="phone" ref="codeFieldRef" />
      <!--登录协议-->
      <protocolField v-model="isChecked" isLogin />
      <!--登录按钮-->
      <div
        class="login-btn"
        :class="{ disabled: disabled }"
        @click="handleLogin"
      >
        登录
      </div>
      <div class="serviceIcon" @click="qimoChatClick" v-if="!showGuide">
        <span class="serviceText">联系客服</span>
        <img src="@/assets/style/landingPage-img.png" alt="" />
      </div>
      <Popup
        ref="popup"
        message="请先阅读并同意相关协议"
        confirmText="我已阅读并同意"
        cancelText="不同意"
        @confirm="handleConfirm"
      />
    </div>
  </div>
</template>

<script>
import LoginGuidePage from "@/components/login/loginGuidePage.vue";
import phoneField from "@/components/login/phoneField.vue";
import codeField from "@/components/login/codeField.vue";
import protocolField from "@/components/protocolField/index.vue";
import Popup from "@/components/Popup/index.vue";

import { login, sign } from "@/api/index.js";
export default {
  name: "Login",
  components: {
    LoginGuidePage,
    phoneField,
    codeField,
    protocolField,
    Popup,
  },
  data() {
    return {
      phone: "",
      code: "",
      isChecked: false,
      showGuide: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name !== "agreement") {
        vm.phone = "";
        vm.code = "";
        vm.isChecked = false;
        vm.$refs.codeFieldRef.init();
        vm.showGuide = false;
      }
    });
  },
  async activated() {
    this.showGuide = localStorage.getItem("showGuideFlag") != '1' ? true : false;
    if (this.showGuide) {
      setTimeout(() => {
        localStorage.setItem("showGuideFlag", '1');
        this.showGuide = false;
      }, 2000);
    }
  },

  methods: {
    //同意并继续登录
    handleConfirm() {
      this.isChecked = true;
    },
    handleLogin() {
      if (this.disabled) {
        return;
      }
      if (!this.isChecked) {
        this.$refs.popup.showPopup();
        return;
      }
      login({
        phoneNumber: this.phone,
        code: this.code,
        platform: "H5",
      }).then(async (res) => {
        if (res.code === 2000) {
          if (res.data.channelSource == "1") {
            this.$toast("暂未开放，请下载app进行使用");
            return;
          } else {
            this.$store.commit("setToken", res.data.token);
            localStorage.setItem("phone", this.phone);
            //调用签署协议接口
            await sign({
              configIds: this.$store.state.agreementList.map(
                (item) => item.configId,
              ),
            });
            this.$router.push({ name: "Home" });
            localStorage.setItem("actived", 1);
          }
        } else {
          this.$toast(res.msg || res.message || "登录失败");
        }
      });
    },
    qimoChatClick() {
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", { type: "8" });
      } else {
        const fromUrl = window.location.href;
        const urlTitle = document.title;
        const nickName = this.userInfo?.username || "";
        const clientId = localStorage.getItem("phone")? `phone_${localStorage.getItem("phone")}` : '';
        window.open(
          `https://ykf-weixin01.7moor.com/wapchat.html?accessId=f12bce20-49ee-11f1-aea3-c5caf3f64abe&fromUrl=${fromUrl}&urlTitle=${urlTitle}&language=ZHCN&nickName=${nickName}&clientId=${clientId}`,
        );
      }
    },
  },
  computed: {
    userInfo(){
      return this.$store.state.userInfo;
    },
    disabled() {
      return !this.phone || !this.code;
    },
  },
};
</script>

<style scoped lang="scss">
.login {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #e2e9f3;
  background-image: url("@/assets/style/login-bg-icon.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 116px;
  .guide-logo-icon {
    width: 80px;
    height: 80px;
  }
  span {
    font-size: 20px;
    color: #1d70f7;
  }
}
.login-content {
  margin: 70px 16px 0px 16px;
  padding: 20px;
  min-height: 400px;
}
.login-btn {
  width: 100%;
  height: 52px;
  background: #1d70f7;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #fff;
  font-weight: 500;
  margin-top: 20px;
}
.disabled {
  background: #8eb7fb;
}
.serviceIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1d70f7;
  font-size: 14px;
  margin-top: 30px;
  font-weight: 500;
  text-decoration: underline;
  text-decoration-color: #C6DBFF; /* 设置下划线/背景线颜色 */
  text-decoration-thickness: 4px; /* 设置背景线粗细 */
  text-underline-offset: -1px; /* 设置线条与文字基线的距离 */
  img {
    width: 20px;
    height: 20px;
    margin-left: 6px;
  }
}
</style>
